module.exports = __webpack_public_path__ + "img/关闭 (2).a5188f74.png";